import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { ContactInfo } from "../types";
import { Order } from "../queries/auto-generated/schemas";

interface UserInitialSliceState {
  contactInfo?: ContactInfo;
  editing: boolean;
  orders: {[key: string]: Order};
  loggedIn: boolean;
  jwt: string;
  passwordResetCode?: string;
  isGuest: boolean;
}

const initialState: UserInitialSliceState = {
  editing: true,
  orders: {},
  loggedIn: false,
  jwt: "",
  isGuest: false
};

const user = createSlice({
  name: "user",
  initialState,
  reducers: {
    updateContactInfo(state, action: PayloadAction<{contactInfo: ContactInfo}>) {
      state.contactInfo = action.payload.contactInfo;
    },
    updatingEditing(state, action: PayloadAction<boolean>) {
      state.editing = action.payload;
    },
    addOrder(state, action: PayloadAction<Order>) {
      const order = action.payload
      state.orders[order.id] = order;
    },
    login(state, action: PayloadAction<{jwt: string; contactInfo: ContactInfo}>) {
      const {jwt, contactInfo} = action.payload;
      if (!!jwt && !!user) {
        state.loggedIn = true;
        state.jwt = jwt;
        state.isGuest = false;
        state.contactInfo = contactInfo;
      }
    },
    logout(state) {
      state.editing = true;
      state.orders = {};
      state.loggedIn = false;
      state.jwt = "";
      state.isGuest = false;
      state.contactInfo = undefined;
      state.passwordResetCode = undefined;
    },
    setPasswordResetCode(state, action: PayloadAction<{code: string | undefined}>){
      state.passwordResetCode = action.payload.code
    },
    becomeGuest(state) {
      state.isGuest = true;
      state.loggedIn = false;
      state.jwt = ""
    },
    stopBeingGuest(state) {
      state.isGuest = false;
    }
  },
});

export default user;
